import styled, { keyframes } from 'styled-components';

const theme = {
  success: '#50fa7b',
  error: '#ff5555',
  warning: '#f1fa8c',
  info: '#8be9fd',
  textDark: '#252836',
  textLight: '#f8f8f2',
};

const slideInUp = keyframes`
  from {
    transform: translate(-50%, 100px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const MessageWrapper = styled.div`
  position: fixed;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  z-index: 99999;
  animation: ${slideInUp} 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  
  &.fade-out {
    animation: ${fadeOut} 0.5s ease-out forwards;
  }

  background-color: ${({ type }) => theme[type] || theme.info};
  color: ${({ type }) => (type === 'warning' ? theme.textDark : type === 'success' ? 'black' : theme.textLight)};
`;

export const IconWrapper = styled.div`
  font-size: 1.5rem;
  margin-right: 1rem;
  display: flex;
  align-items: center;
`;

export const MessageText = styled.p`
  margin: 0;
  font-weight: 600;
  font-size: 0.95rem;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  font-size: 1.2rem;
  margin-left: 1.5rem;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 1;
  }
`;